import {componentsDoc} from './components';
import {widgetsDoc} from './widgets';

export const docs = {...componentsDoc, ...widgetsDoc};
